module.exports = {
    type: 'Fill in the blanks',
    instruction1: 'Type the statement of the question below.',
    instruction2: 'Type the sentence that must be completed by the student. The result will appear in the text box below. The words that will appear as blank spaces (in which the student will type the answer) must be delimited by percent signs (%). Example: Two plus two is %four%.',
    typeHere: 'Type here...',
}